<template>
  <div class="filter">
    <div class="filter__section" v-if="dataSubject && dataSubject.length > 0">
      <div class="filter__title secondary-color-txt font-sanpro-semibold">Nội dung</div>
      <div class="filter__form">
        <div class="radio-custom item">
          <input
            v-if="paramSearchLessons.filterType === typePagelinks"
            type="radio"
            name="subjectId"
            :value="0"
            @change="handleChangeFilterKey"
            v-model="paramFilterBook.subjectId"
          />
          <input
            v-else
            type="radio"
            name="subjectId"
            :value="0"
            @change="handleChangeFilterKey"
            v-model="paramFilterBookLesson.subjectId"
          />
            <!-- :checked="(paramSearchLessons.filterType === typePagelinks && paramFilterBook.subjectId === 0) || (paramSearchLessons.filterType === typeLesson && paramFilterBookLesson.subjectId === 0)" -->
          <label class="color-form secondary-color-txt font-sanpro-light">Tất cả</label>
        </div>
        <div class="radio-custom item" v-for="(item, index) of dataSubject" :key="index">
          <input
            v-if="paramSearchLessons.filterType === typePagelinks"
            type="radio"
            name="subjectId"
            :value="item.subjectId"
            @change="handleChangeFilterKey"
            v-model="paramFilterBook.subjectId"
          />
          <input
            v-else
            type="radio"
            name="subjectId"
            :value="item.subjectId"
            @change="handleChangeFilterKey"
            v-model="paramFilterBookLesson.subjectId"
          />
            <!-- :checked="(paramSearchLessons.filterType === typePagelinks && paramFilterBook.subjectId === item.subjectId) || (paramSearchLessons.filterType === typeLesson && paramFilterBookLesson.subjectId === item.subjectId)" -->
          <label class="color-form secondary-color-txt font-sanpro-light">{{ item.name }}</label>
        </div>
      </div>
    </div>
    <div class="filter__section" v-if="dataBookGroup && dataBookGroup.length > 0">
      <div class="filter__title secondary-color-txt font-sanpro-semibold">Bộ sách</div>
      <div class="filter__form">
        <div class="radio-custom item">
          <input
            v-if="paramSearchLessons.filterType === typePagelinks"
            type="radio"
            name="bookGroupId"
            :value="0"
            v-model="paramFilterBook.bookGroupId"
            @change="handleChangeFilterKey"
          />
          <input
            v-else
            type="radio"
            name="bookGroupId"
            :value="0"
            v-model="paramFilterBookLesson.bookGroupId"
            @change="handleChangeFilterKey"
          />
            <!-- :checked="(paramSearchLessons.filterType === typePagelinks && paramFilterBook.bookGroupId === 0) || (paramSearchLessons.filterType === typeLesson && paramFilterBookLesson.bookGroupId === 0)" -->
          <label class="color-form secondary-color-txt font-sanpro-light">Tất cả</label>
        </div>
        <div class="radio-custom item" v-for="(item, index) of dataBookGroup" :key="index">
          <input
            v-if="paramSearchLessons.filterType === typePagelinks"
            type="radio"
            name="bookGroupId"
            :value="item.bookGroupId"
            v-model="paramFilterBook.bookGroupId"
            @change="handleChangeFilterKey"
          />
          <input
            v-else
            type="radio"
            name="bookGroupId"
            :value="item.bookGroupId"
            v-model="paramFilterBookLesson.bookGroupId"
            @change="handleChangeFilterKey"
          />
            <!-- :checked="(paramSearchLessons.filterType === typePagelinks && paramFilterBook.bookGroupId === item.bookGroupId) || (paramSearchLessons.filterType === typeLesson && paramFilterBookLesson.bookGroupId === item.bookGroupId)" -->
          <label class="color-form secondary-color-txt font-sanpro-light">{{ item.name }}</label>
        </div>
      </div>
    </div>
    <div class="filter__section" v-if="dataLinkTypes && dataLinkTypes.length > 0 && this.$route.query.tab !== 3">
      <div class="filter__title secondary-color-txt font-sanpro-semibold">Loại học liệu</div>
      <div class="filter__form">
        <div class="radio-custom item">
          <input
            v-if="paramSearchLessons.filterType === typePagelinks"
            type="radio"
            name="pagelinkTypeId"
            :value="0"
            v-model="paramFilterBook.pagelinkTypeId"
            @change="handleChangeFilterKey"
          />
          <input
            v-else
            type="radio"
            name="lessonGroupId"
            :value="0"
            v-model="paramFilterBookLesson.lessonGroupId"
            @change="handleChangeFilterKey"
          />
            <!-- :checked="(paramSearchLessons.filterType === typePagelinks && paramFilterBook.pageLinkGroupId === 0) || (paramSearchLessons.filterType === typeLesson && paramFilterBookLesson.lessonGroupId === 0)" -->
          <label class="color-form secondary-color-txt font-sanpro-light">Tất cả</label>
        </div>
        <div class="radio-custom item" v-for="(item, index) of dataLinkTypes" :key="index">
          <input
            v-if="paramSearchLessons.filterType === typePagelinks"
            type="radio"
            name="pagelinkTypeId"
            :value="item.pageLinkGroupId"
            v-model="paramFilterBook.pagelinkTypeId"
            @change="handleChangeFilterKey"
          />
          <input
            v-else
            type="radio"
            name="lessonGroupId"
            :value="item.pageLinkGroupId"
            v-model="paramFilterBookLesson.lessonGroupId"
            @change="handleChangeFilterKey"
          />
            <!-- :checked="(paramSearchLessons.filterType === typePagelinks && paramFilterBook.pageLinkGroupId === item.pageLinkGroupId) || (paramSearchLessons.filterType === typeLesson && paramFilterBookLesson.lessonGroupId === item.pageLinkGroupId)" -->
          <label class="color-form secondary-color-txt font-sanpro-light">{{ item.name }}</label>
        </div>
      </div>
    </div>
    <div class="filter__section filter__section__action display-flex-center justify-content-between">
      <a href="javascript:;"  v-if="this.$route.query.tab !== 3" class="filter__section__modal primary-color font-size-16" @click="showModalReadmore">Tìm hiểu thêm về <i>"</i> Loại học liệu <i>"</i></a>
      <a href="javascript:;"  v-else class="filter__section__modal primary-color font-size-16"></a>
      <div class="filter__section__form">
        <a href="javascript:;" class="primary-color font-sanpro-semibold" @click="resetSearchFilter">Làm mới</a>
        <a href="javascript:;" class="btn btn-main border-rd-20 btn-submit font-sanpro-semibold" @click="handleFilterBook(false)">Lọc</a>
      </div>
    </div>
    <ModalReadMoreLinkType v-if="openModalReadmore" />
  </div>
</template>

<script>
  import { STORE_KEY, TAB_MEDIA_PAGE_LINK, TAB_LESSON, ID_MODAL_READ_LINK_TYPE, TAB_ACTIVE_LEARNING } from './../../_store/constants'
  import { mapState, mapActions } from 'vuex'
  import { getAllTypeFilter } from './../../_api/'
  import ModalReadMoreLinkType from './ModalReadMoreLinkType.vue'

  export default {
    name: 'FilterCollapse',
    components: {
      ModalReadMoreLinkType
    },
    data () {
      return {
        queryTab: parseInt(this.$route.query.tab),
        dataSubject: [],
        dataBookGroup: [],
        dataLinkTypes: [],
        typePagelinks: TAB_MEDIA_PAGE_LINK,
        typeLesson: TAB_LESSON,
        tabActiveLearning: TAB_ACTIVE_LEARNING,
        openModalReadmore: false
      }
    },
    computed: {
      ...mapState(STORE_KEY, ['paramSearchLessons', 'paramFilterBook', 'paramFilterBookLesson', 'paramActiveLearning']),
    },
    watch: {
      'paramSearchLessons.classId': 'getTypesFilter',
      'paramSearchLessons.filterType': 'getTypesFilter'
    },
    mounted () {
      this.getTypesFilter(true)
    },
    methods: {
      ...mapActions(STORE_KEY, ['acSetParamFilterBook', 'acGetBookOfPageLinks', 'acGetBookOfLessons', 'acGetBookActiveLearning', 'acSetParamFilterBookLesson', 'acResetBookFilterLib', 'setParamSearchLesson', 'acSetParamActiveLearning']),
      ...mapActions("common", ["setLoading"]),

      getTypesFilter (isMounted = false) {
        let self = this
        let params = {
          classId: self.$route.query.lop ? parseInt(self.$route.query.lop) : self.paramSearchLessons.classId,
          filterType: self.paramSearchLessons.filterType
        }
        params.classId !== 0 && getAllTypeFilter(params).then(res => {
          if (res && res.data && !res.errors) {
            self.dataBookGroup = res.data.ltsBookType
            self.dataSubject = res.data.ltsSubject
            self.dataLinkTypes = self.paramSearchLessons.filterType === TAB_ACTIVE_LEARNING ? [] : res.data.ltsPagelinktype
            isMounted && self.setValueFilterCurr()
          }
        })
      },

      async setValueFilterCurr () {
        if ((this.$route.query.mon && this.$route.query.mon !== '0') || (this.$route.query.nhom && this.$route.query.nhom !== '0') ) {
          let tabActive = this.$route.query.tab
          let classActive = this.$route.query.lop && this.$route.query.lop !== '0' ? parseInt(this.$route.query.lop) : 0
          let subjectActive = this.$route.query.mon && this.$route.query.mon !== '0' ? parseInt(this.$route.query.mon) : 0
          let groupActive = this.$route.query.nhom && this.$route.query.nhom !== '0' ? parseInt(this.$route.query.nhom) : 0

          if (tabActive && parseInt(tabActive) === this.typeLesson) {
            await this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, classId: classActive, subjectId: subjectActive, bookGroupId: groupActive})
          } else if(tabActive && parseInt(tabActive) === this.typePagelinks){
            await this.acSetParamFilterBook({...this.paramFilterBook, classId: classActive, subjectId: subjectActive, bookGroupId: groupActive})
          } else if(tabActive && parseInt(tabActive) === this.tabActiveLearning){
            await this.acSetParamActiveLearning({...this.paramActiveLearning, classId: classActive, subjectId: subjectActive, bookGroupId: groupActive})
          }
          this.handleFilterBook(true)
          this.$root.$emit('bv::toggle::collapse', 'collapse_filter')
        }
      },

      handleChangeFilterKey (evt) {
        let self = this
        let key = evt.target.name;
        let value = parseInt(evt.target.value);
        let tabActive = this.$route.query.tab ? parseInt(this.$route.query.tab) : 1
        if(tabActive === TAB_MEDIA_PAGE_LINK) {
          self.acSetParamFilterBook({...self.paramFilterBook, [key]: value})
        } else if(tabActive === TAB_LESSON){
          self.acSetParamFilterBookLesson({...self.paramFilterBookLesson, [key]: value})
        } else if(tabActive === TAB_ACTIVE_LEARNING){
          self.acSetParamActiveLearning({...self.paramActiveLearning, [key]: value})
        }
      },

      async handleFilterBook (isMounted = false) {
        let tabActive = this.$route.query.tab
        // Mounted component  has log filter book
        let mountedHasLogFilterBook = this.$route.query.bookf ? parseInt(this.$route.query.bookf) : 0
        if((isMounted && tabActive && parseInt(tabActive) === TAB_MEDIA_PAGE_LINK) || (!isMounted && this.paramSearchLessons.filterType === TAB_MEDIA_PAGE_LINK)) {
          !isMounted && this.acSetParamFilterBook({...this.paramFilterBook, classId: this.paramSearchLessons.classId, pageIndex: 1})
          const { subjectId, bookGroupId, pagelinkTypeId } = this.paramFilterBook
          this.setParamSearchLesson({...this.paramSearchLessons, subjectId, bookGroupId, pagelinkTypeId, pageIndex: 1 })
          this.acGetBookOfPageLinks(this.paramFilterBook)
        } else if((isMounted && tabActive && parseInt(tabActive) === TAB_LESSON) || (!isMounted && this.paramSearchLessons.filterType === TAB_LESSON)){
          !isMounted && this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, classId: this.paramSearchLessons.classId, pageIndex: 1})
          const { subjectId, bookGroupId, lessonGroupId } = this.paramFilterBookLesson
          this.setParamSearchLesson({...this.paramSearchLessons, subjectId, bookGroupId, lessonGroupId, pagelinkTypeId: 0, pageIndex: 1 })
          this.acGetBookOfLessons(this.paramFilterBookLesson)
        } else if((isMounted && tabActive && parseInt(tabActive) === TAB_ACTIVE_LEARNING) || (!isMounted && this.paramSearchLessons.filterType === TAB_ACTIVE_LEARNING)){
          !isMounted && this.acSetParamActiveLearning({...this.paramActiveLearning, classId: this.paramSearchLessons.classId, pageIndex: 1})
          const { subjectId, bookGroupId, lessonGroupId } = this.paramActiveLearning
          this.setParamSearchLesson({...this.paramSearchLessons, subjectId, bookGroupId, lessonGroupId, pagelinkTypeId: 0, pageIndex: 1 })
          // this.acGetBookOfPageLinks(this.paramFilterBook)
          console.log('zxc', this.paramActiveLearning);
          this.acGetBookActiveLearning(this.paramActiveLearning)
        }
        this.$root.$emit('bv::toggle::collapse', 'collapse_filter');
        this.$emit('search', this.paramSearchLessons.filterType)
      },

      resetSearchFilter () {
        this.acResetBookFilterLib()
        this.acSetParamFilterBook({subjectId: 0, bookGroupId: 0, classId: 0, pagelinkTypeId: 0, pageIndex: 1, pageSize: 12})
        this.acSetParamFilterBookLesson({subjectId: 0, bookGroupId: 0, classId: 0, lessonGroupId: 0, pageIndex: 1, pageSize: 12})
        this.acSetParamActiveLearning({subjectId: 0, bookGroupId: 0, classId: 0, lessonGroupId: 0, pageIndex: 1, pageSize: 12})

      },

      showModalReadmore () {
        if (this.openModalReadmore) {
          this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
        } else {
          this.openModalReadmore = true
          setTimeout(() => {
            this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
          }, 500);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.filter {
  &__form {
    @extend .display-flex-wrap;

    .item {
      width: calc(100%/5);
      margin-bottom: 6px;

      @media screen and ( min-width: 992px ) and ( max-width: 1199px ) {
        width: calc(100%/4);
      }

      @media screen and ( min-width: 768px ) and ( max-width: 991px ) {
        width: calc(100%/3);
      }

      @media screen and ( min-width: 576px ) and ( max-width: 767px ) {
        width: calc(100%/2);
      }
      @media screen and ( max-width: 575px ) {
        width: 100%;
      }
    }
  }

  &__title {
    margin-bottom: 10px;
  }

  &__section {
    margin-bottom: 20px;
  }
}
.radio-custom {
  input {
    &:checked ~ label {
      @extend .primary-color;
    }
  }
}
.btn-submit {
  width: 100px;
  margin-left: 25px;
}
@media screen and ( max-width: 600px ) {
  .filter {
    &__section {
      &__action, &__modal {
        display: block;
      }

      &__modal {
        margin-bottom: 10px;
      }
    }
  }
}
</style>